export default "__VITE_ASSET__DQ5NifHY__"